import { render, staticRenderFns } from "./TermsOfUseModal.vue?vue&type=template&id=1c57dc65&scoped=true"
import script from "./TermsOfUseModal.vue?vue&type=script&lang=ts"
export * from "./TermsOfUseModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57dc65",
  null
  
)

export default component.exports